class BackToTop {
	constructor() {
		this.backToTopBtn = document.querySelector('.back-to-top');
		if (!this.backToTopBtn) return;

		this.progressCircle = this.backToTopBtn.querySelector('.progress-circle__bar');
		this.footer = document.querySelector('.w4d-footer, footer');

		const computedStyle = window.getComputedStyle(this.backToTopBtn);
		this.defaultBottomOffset = parseInt(computedStyle.bottom, 10) || 32;

		this.supportsScrollTimeline =
			Boolean(window.CSS?.supports) &&
			(CSS.supports('((animation-timeline: scroll()) and (animation-range: 0% 100%))') ||
				(CSS.supports('animation-timeline', 'scroll()') && CSS.supports('animation-range', '0% 100%')));

		if (this.progressCircle) {
			this.totalLength = this.progressCircle.getTotalLength() || 201.06;
			this.progressCircle.style.strokeDasharray = `${this.totalLength}`;
			if (!this.supportsScrollTimeline) {
				this.progressCircle.style.strokeDashoffset = `${this.totalLength}`;
			}
		}

		this.init();
	}

	init() {
		this.initVisibilityObserver();
		this.initFooterObserver();

		// JS Fallback for progress circle if CSS scroll-driven animations are unsupported
		if (!this.supportsScrollTimeline && this.progressCircle) {
			this.initFallbackProgress();
		}

		this.bindEvents();
	}

	initVisibilityObserver() {
		this.sentinel = document.createElement('div');
		this.sentinel.className = 'w4d-back-to-top-sentinel';
		this.sentinel.setAttribute('aria-hidden', 'true');
		this.sentinel.style.cssText = 'position:absolute;top:0;left:0;height:600px;width:1px;pointer-events:none;opacity:0;';
		document.body.prepend(this.sentinel);

		this.visibilityObserver = new IntersectionObserver(
			([entry]) => {
				const isVisible = !entry.isIntersecting;
				this.backToTopBtn.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
			},
			{
				root: null,
				threshold: 0,
			}
		);
		this.visibilityObserver.observe(this.sentinel);
	}

	initFooterObserver() {
		if (!this.footer) return;

		this.footerObserver = new IntersectionObserver(
			([entry]) => {
				this.backToTopBtn.classList.toggle('is-over-footer', entry.isIntersecting);
			},
			{
				root: null,
				rootMargin: `0px 0px -${this.defaultBottomOffset + 10}px 0px`,
				threshold: 0,
			}
		);
		this.footerObserver.observe(this.footer);
	}

	initFallbackProgress() {
		let ticking = false;

		const updateProgress = () => {
			const scrollTop = window.scrollY || document.documentElement.scrollTop;
			const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;

			if (scrollHeight > 0) {
				const progress = Math.min(Math.max(scrollTop / scrollHeight, 0), 1);
				const offset = this.totalLength - progress * this.totalLength;
				this.progressCircle.style.strokeDashoffset = `${offset}`;
			}

			ticking = false;
		};

		const onScroll = () => {
			if (!ticking) {
				requestAnimationFrame(updateProgress);
				ticking = true;
			}
		};

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll, { passive: true });
		updateProgress();
	}

	bindEvents() {
		this.backToTopBtn.addEventListener('click', (e) => {
			e.preventDefault();
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
			if (window.location.hash) {
				history.pushState('', document.title, window.location.pathname + window.location.search);
			}
		});
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		new BackToTop();
	});
} else {
	new BackToTop();
}